import { httpClient } from "../httpClient";

const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL as string;
const USER_DOMAIN = process.env.REACT_APP_USER_DOMAIN as string
const XSM_APPLICATION = process.env.REACT_APP_XSM_APPLICATION as string

export const forgotPassword = (email: string) => {
	const headers = {
    "Content-Type": "application/json",
    "Xsm-Domain": USER_DOMAIN,
    "xsm-application": XSM_APPLICATION,
  }

	return httpClient.post(`${process.env.REACT_APP_XSM_API_BASE_URL}/xsm-api/v1/admin/user/recover-password`, {
		email,
		callbackurl: CALLBACK_URL
	},{},headers);
};

export const resetPassword = (password: string, email: string,
	key: string) => {

	const headers = {
    "Content-Type": "application/json",
    "Xsm-Domain": USER_DOMAIN,
    "xsm-application": XSM_APPLICATION,
  }

	return httpClient.post(`${process.env.REACT_APP_XSM_API_BASE_URL}/xsm-api/v1/admin/user/set-password`, {
		password,
        email,
        key
	},{},headers);
};